//
// Bonus Multiview View
// --------------------

define(function(require, exports, module) {
    'use strict';
    var $ = require('j');
    var core = require('core');
    var PortletView = require('modules/portlet/portlet.view');
    var BonusMultiviewBonusCollection = require('portlets/bonus-multiview/bonusmultiview.bonus.collection');
    var BonusStrategy = require('portlets/bonus-multiview/bonusmultiview.bonus.strategy');
    var config = require('config');

    require('widgets/scroller.widget');

    var BonusMultiviewView = PortletView.extend({

        className: 'bonus-multiview',

        events: {
            'tap .fn-show-tc': 'showTC',
            'tap .fn-multiview-bonus': 'showMoreInfo',
            'tap .fn-get-bonus': 'getBonus'
        },

        initialize: function() {
            PortletView.prototype.initialize.apply(this, arguments);

            this.collection = new BonusMultiviewBonusCollection(null, this.options.config);
            this.fetchBonusCollection();
        },

        onFetchRender: function() {
            this.state.then(() => this.renderPortletContent());
        },

        subscribe: function() {
            this.listenTo(this.collection, 'change', this.onChange);
            this.listenTo(core, 'deposit:success', function() {
                this.fetchBonusCollection();
                this.renderPortletContent();
            });
        },

        template: function(data) {
            var portletConfig = this.options.config;
            portletConfig.responsive = portletConfig.responsive || false;

            var templateName = portletConfig.viewType === 'imagelistview'
                ? 'bonus-multiview.imageview'
                : 'bonus-multiview.listview';

            return this.tmpl(templateName, {
                data: data,
                config: portletConfig
            });
        },

        render: function() {
            this.$el.html(this.template({showLoader: true}));

            return this;
        },

        fetchBonusCollection: function() {
            this.state = this.collection.fetch();
        },

        renderPortletContent: function() {
            return this.state
                .done(function() {
                    this.$el.html(this.template(this.collection.toJSON()));

                    if (this.options.config.viewType === 'imagelistview') {
                        this._renderWebContents();
                    } else {
                        this._addScrollers();
                    }
                }.bind(this))
                .fail(this.renderNetworkError.bind(this));
        },

        /**
         * Render portlet after mounting to DOM
         * @return {Deferred}
         */
        portletDidMount: function() {
            return this.renderPortletContent();
        },

        _addScrollers: function() {
            this.$('.bonus-multiview-listview').scroller({
                numberOfRows: this.options.config.numberOfRows,
                heading: this.$('.fn-bonus-multiview-header'),
                content: this.$('.fn-bonus-multiview-container')
            });

            this.$('.bonus-multiview-imageview').scroller({
                numberOfRows: this.options.config.numberOfRows
            });
        },

        _renderWebContents: function() {
            var container = this.$('.fn-webcontent-container');

            var states = this.collection.map(function(model, index) {
                var state = $.Deferred();

                this.loadContent(model.get('listViewWebContentId')).always(function(content) {
                    if (container[index]) {
                        container[index].innerHTML = content || '';
                    }

                    state.resolve();
                });

                return state.promise();
            }, this);

            return $.when.apply($, states)
                .done(this._addScrollers.bind(this));
        },

        /**
         * Show more info popup
         * @param {Event} e
         */
        showMoreInfo: function(e) {
            e.preventDefault();

            var bonusLinkUrl = config.get('bonusManagementPreferences.bonusDeepLinkingUrl');
            var bonus = this.collection.get(e.currentTarget.dataset.bonusCode);
            var bonusDynamicLink = bonusLinkUrl ? bonusLinkUrl.replace(/^\//, '') : 'promotions';

            core.navigate('/' + bonusDynamicLink + '/' + bonus.get('seoFriendlyBonusName'));
        },

        /**
         * Get free bonus
         * @param  {Event}  e
         */
        getBonus: function(e) {
            BonusStrategy.getBonus(this.collection.get(e.target.dataset.bonusCode));
        },

        /**
         * Show T&C popup
         * @param  {Event}  e
         */
        showTC: function(e) {
            e.stopImmediatePropagation();

            BonusStrategy.showTC(this.collection.get(e.target.dataset.bonusCode));
        },

        /**
         * @deprecated use `BonusMultiviewView.toggleOptButton()`
         */
        toggleOptButton: function() {
            return BonusMultiviewView.toggleOptButton.apply(this, [this].concat([].slice.call(arguments)));
        },

        showLoginPopup: function() {
            BonusStrategy.showLoginPopup();
        },

        onChange: function(model) {
            BonusMultiviewView.toggleOptButton(this, model);
        },

        close: function() {
            function destroyWidget(el) {
                el.widgets && el.widgets.scroller.destroy();
            }

            this.$('.bonus-multiview-listview').forEach(destroyWidget);
            this.$('.bonus-multiview-imageview').forEach(destroyWidget);

            PortletView.prototype.close.apply(this, arguments);
        }

    }, {

        /**
         * Change title for action title
         * @param {View} view - view where bonus is presented
         * @param {Model} model - bonus model
         */
        toggleOptButton: function(view, model) {

            // todo type check for optin/optout only
            if (model.get('type') !== 'optIn' && model.get('type') !== 'optOut') {
                return;
            }

            var $button = view.$('.fn-get-bonus[data-bonus-code="' + model.get('bonusCode') + '"]');

            if (!$button.length) {
                return;
            }

            $button
                .removeClasses(/^btn_type_.*/)
                .addClass('btn_type_' + model.get('type'))
                .html(view.translate(model.get('actionTitle')));
        }

    });

    module.exports = BonusMultiviewView;
});
